"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeTokenCache = void 0;
const makeTokenCache = (getToken) => {
    let cache;
    return (...args) => {
        if (!cache) {
            cache = getToken(...args);
        }
        return cache
            .then((result) => {
            setTimeout(() => (cache = null), result.expires_in * 1000);
            return result;
        })
            .catch((e) => {
            cache = null;
            throw e;
        });
    };
};
exports.makeTokenCache = makeTokenCache;
//# sourceMappingURL=makeTokenCache.js.map